import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

function Copyright() {
  return (
    <Typography variant="body1" align="center">
      &copy;
      &nbsp;
      {new Date().getFullYear()}
      &nbsp;
      <Link color="inherit" href="https://www.childcareaware.org/">
        Child Care Aware&reg; of America. All Rights Reserved.
      </Link>
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    display: 'none',
    '@media print': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: '#FFF !important',
      marginTop: theme.spacing(8),
      padding: theme.spacing(4, 0),
      position: 'fixed',
      bottom: 0,
      display: 'block !important',
      width: '100%',
    },
  },
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <footer className={`${classes.footer} pageFooter`} style={{ flexGrow: 1 }}>
      <Copyright />
    </footer>
  );
}
